import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import BrandLogo from "@/components/BrandLogo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Şifre en az 8 karakter olmalıdır.");
    if (password !== confirm) return setError("Şifreler eşleşmiyor.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Şifreniz güncellendi. Şimdi giriş yapabilirsiniz.");
      nav("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="w-full max-w-[420px]" data-testid="reset-page">
        <div className="mb-10">
          <BrandLogo size="lg" />
        </div>

        <h1 className="text-3xl tracking-tight font-bold text-slate-900 mb-2">Yeni Şifre Belirle</h1>
        <p className="text-sm text-slate-500 mb-8">Yeni şifrenizi belirleyerek hesabınıza tekrar erişebilirsiniz.</p>

        {!token ? (
          <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-4 py-3">
            Geçersiz veya eksik bağlantı.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Yeni şifre (en az 8 karakter)"
              data-testid="reset-password"
              className="w-full h-11 rounded-lg border border-slate-200 bg-white px-4 text-sm focus:outline-none focus:ring-1 focus:ring-slate-400 focus:border-slate-400 placeholder:text-slate-400"
            />
            <input
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Yeni şifre (tekrar)"
              data-testid="reset-confirm"
              className="w-full h-11 rounded-lg border border-slate-200 bg-white px-4 text-sm focus:outline-none focus:ring-1 focus:ring-slate-400 focus:border-slate-400 placeholder:text-slate-400"
            />
            {error && <div className="text-sm text-red-600">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="reset-submit"
              className="w-full rounded-full bg-slate-900 text-white hover:bg-slate-800 h-11 font-medium transition-colors duration-150 disabled:opacity-50"
            >
              {loading ? "Güncelleniyor..." : "Şifreyi Güncelle"}
            </button>
          </form>
        )}

        <div className="mt-6 text-sm">
          <Link to="/login" className="text-slate-500 hover:text-slate-900 transition-colors">← Girişe dön</Link>
        </div>
      </div>
    </div>
  );
}
